export default "__VITE_ASSET__CbDK8CqM__"